var $ = global.jQuery = global.$;
var widgets = require('../lib/widgets');

var _Base = require('./_Base');

var itemTemplate = function(name) {
  return '<div class="upload-area__item">' + name + '</div>';
};

var Upload = _Base.extend({
  init: function() {
    var self = this;
    var $item = $('.upload-area__item');
    var $remove = $('.upload-clear__button');
    this.$uploadArea = this.$el.find('[data-uploads]');
    this.$el.on('Files:updated', function(event, files) {
      self.currentFiles = files;
      self.updateFiles();
    });
    $remove.on('click', function(event) {
      event.preventDefault();
      self.clearImageList();
    });
  },
  onWidgetsReady: function() {
    this.upload = widgets.getDescendants(this.$el,'UploadField')[0];
  },
  updateFiles: function() {
    var self = this;
    if (this.currentFiles.length) {
      $.each(this.currentFiles, function() {
        var $item = $(itemTemplate(this.name));
        self.$uploadArea.append($item);
      });
    }
  },
  clearImageList: function() {
    this.$uploadArea.empty();
    this.upload.clearList();
  }
});

module.exports = Upload;



//////////////////
// WEBPACK FOOTER
// ./source/scripts/widgets/Upload.js
// module id = 122
// module chunks = 0